<template>
  <div class="navbar-header">
    <b-navbar toggleable="lg" type="dark" variant="info" class="p-2 pe-0 py-1">
      <b-navbar-brand>
        <div class="d-flex align-items-center">
          <!-- <img
            src="../../../../assets/Img/icons/menu.svg"
            @click="visibleLeft = true"
            class="me-2 icon-size Hamburger-menu"
          /> -->
          <!-- <Sidebar class="header-right-sidebar" v-model:visible="visibleLeft" :baseZIndex="10000">
            <template #header>
              <div>
                <i class="pi pi-times pt-3" style="font-size: 1.5rem; color: #ffffff" @click="closesidebar()"></i>
              </div>
            </template>
<ul class="my-3">
  <li class="s-list" v-for="(menu, index) in menuarray" :key="index" @click="masters(menu.FixedHref)">
    <div class="d-flex align-items-center">
      <img :src="menu.Image" class="list-icon" />
      <span>{{ menu["SubMenuName"] }}</span>
    </div>
    <div>
      <i class="pi pi-angle-right"></i>
    </div>
  </li>


</ul>
</Sidebar> -->
          <StoreDropDown @StoreChanged="StoreChanged" />
        </div>
      </b-navbar-brand>
      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ms-auto align-items-center">
       
      </b-navbar-nav>
    </b-collapse> -->
      <div class="ms-auto align-items-center d-flex">
        <div class="appsicon mx-4">
          <img src="../../../../assets/Img/icons/appsicon.svg" alt="" @click="mobileoptiontoggle" />
          <div class="inventorymobiletoggle" v-if="mobileoptionvisible">
            <div>
              <img src="../../../../assets/Img/icons/notificationimg.svg"
                class="inventory-header-images position-relative" />
              <!-- <Badge class="inventory-notification-badge" severity="danger"></Badge> -->
              <p>Notification</p>
            </div>
            <div @click="
              router.push({ path: '/IcodeTemplate' }),
              (mobileoptionvisible = false)
              ">
              <img src="../../../../assets/Img/icons/codetemplateimg.svg" class="inventory-header-images" />
              <p>Code Template</p>
            </div>
            <div @click="
              router.push({ path: '/userdashboard' }),
              (mobileoptionvisible = false)
              ">
              <img src="../../../../assets/Img/icons/settingimg.svg" class="inventory-header-images" />
              <p>Settings</p>
            </div>
          </div>
        </div>
        <div class="inventorysettings">
          <div class="entitylistbg mx-3" @click="entitytoggle" aria-haspopup="true" aria-controls="entity_menu">
            <span> Work List </span>
            <span v-if="pendingrequestcount !== '0'">
              <Badge severity="warning">{{ pendingrequestcount }}</Badge>
            </span>
          </div>
          <!-- <div class="entitylistbg mx-3" @click="Pendingtoggle" aria-haspopup="true" aria-controls="pending_type">
            <span> Pending List </span>
            <span class="ms-3">
              <Badge severity="warning">{{ pendingListcount }}</Badge>
            </span>
          </div> -->
          <Menu ref="entitymenu" id="entity_menu" :popup="true">
            <template #start>
              <div class="entitymenu_bg">
                <div v-for="items in entityitems">
                  <div @click="poapprovaltablecall(items['EntityId'])">
                    <p>{{ items["Name"] }}</p>
                    <Badge severity="warning">{{ items["ListCount"] }}</Badge>
                  </div>
                </div>
              </div>
            </template>
          </Menu>
          <Menu ref="PendingTypemenu" id="pending_type" :popup="true">
            <template #start>
              <div class="entitymenu_bg">
                <div v-for="(item, index) in PendingType" :key="index">
                  <div @click="PendingListChange(item['EntityId'])">
                    <p>{{ item["Category"] }}</p>
                    <div class="d-flex align-items-center gap-3">
                      <Badge severity="warning" title="Total Pending Count">{{ item["Count"] }}</Badge>
                      <Badge severity="danger" title="Pending > 24 Hours">{{ item["OneDayPendingCount"] }}</Badge>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Menu>
          <div class="position-relative" @click="Pendingtoggle" aria-haspopup="true" aria-controls="pending_type">
            <img src="../../../../assets/Img/icons/notificationimg.svg" class="inventory-header-images mx-4 mt-2" />
            <Badge class="inventory-notification-badge" severity="danger">{{
              pendingListcount
            }}</Badge>
          </div>
          <div>
            <img src="../../../../assets/Img/icons/codetemplateimg.svg" class="inventory-header-images"
              @click="router.push({ path: '/IcodeTemplate' })" />
          </div>
          <!-- <div>
            <img src="../../../../assets/Img/icons/settingimg.svg" class="inventory-header-images mx-4"
              @click="router.push({ path: '/userdashboard' })" />
          </div> -->
          <div>
            <img src="../../../../assets/Img/icons/apps.svg" class="inventory-header-images mx-4"
              style="width: 24px !important;" @click="ModuleSwitcherpopup = true" />
          </div>

        </div>

        <div class="localedropdown">
          <Dropdown v-model="$i18n.locale" :options="$i18n.availableLocales.map((locale) => locale)" />
        </div>

        <div class="profile">
          <div class="flex justify-content-center">
            <Avatar :label="ProfileData.UserNameFirstLetter" class="avatar" @click="toggle" aria-haspopup="true"
              aria-controls="overlay_menu" style="background-color: rgb(193, 223, 255); color: #000" />
            <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" class="profilemenu">
              <template #start class="profile-box">
                <div class="flex flex-column align menuhead">
                  <div class="d-flex" style="gap: 10px">
                    <Avatar :label="ProfileData.UserNameFirstLetter" class="avatar header-avatar avatar-shape"
                      @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" />

                    <div>
                      <p class="menu-heading1">{{ ProfileData.UserName }}</p>
                      <p class="light-txt" style="color: coral">
                        {{ ProfileData.RoleName }}
                      </p>
                      <p class="light-txt">{{ ProfileData.phoneNumber }}</p>
                    </div>
                  </div>
                  <b-row>
                    <b-col>
                      <div class="field pt-2 mb-0">
                        <Dropdown v-model="SelectedBranchId" :options="BranchDropDown.BranchOption"
                          optionLabel="BranchName" placeholder="Choose Branch" @change="BranchOnChange" />
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="field pt-2 mb-0">
                        <Dropdown v-model="SelectedRoleId" :options="RoleDropDown.RoleOption" optionLabel="RoleName"
                          placeholder="Choose Role" @change="RoleOnchange" />
                      </div>
                    </b-col>
                  </b-row>
                  <!-- <p class="d-flex flex-row-reverse blue-small-txt" @click="Changepasswordpopup = true">
                    Change Password
                  </p> -->
                  <p class="d-flex flex-row-reverse blue-small-txt" @click="router.push('/resetpassword')">
                    Reset password
                  </p>
                </div>

                <button class="w-full p-link flex align-items-center text-color hover:surface-200 border-noround">
                  <i class="pi pi-sign-out" />
                  <span @click="LogOut()">Log Out</span>
                </button>
              </template>
            </Menu>
          </div>
        </div>
      </div>
      <!-- Module Switcher Component -->
      <ModuleSwitcher v-model:visible="ModuleSwitcherpopup" :modules="modules" :loading="moduleLoading"
        :error="moduleError" @close="ClearModuleData" />

      <Dialog v-model:visible="Changepasswordpopup" modal header="Change Password" :style="{ width: '50vw' }"
        :breakpoints="{
          '1980px': '50vw',
          '1440px': '50vw',
          '960px': '70vw',
          '640px': '90vw',
        }" @after-hide="IsClear">
        <b-container fluid>
          <b-form @submit.prevent="IsStoreSubmit">
            <b-row class="mb-4">
              <b-col lg="8" md="8" sm="12" cols="12">
                <div class="field mb-0 position-relative">
                  <div class="blue-txt pwd-icon" @click="showhide()">
                    <i v-if="showpass == true" class="pi pi-eye-slash"></i>
                    <i v-else class="pi pi-eye"></i>
                  </div>
                  <TextField :txttype="showtxt" v-model="ChangePasswordObjVal.newpassword" placeholder=" " clearable
                    name="New Password" label="New Password" :rules="{ required: true, alphanumeric: true }"
                    id="New Password" :required-icon="true" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="8" md="8" sm="12" cols="12">
                <div class="field mb-0 position-relative">
                  <div class="blue-txt pwd-icon" @click="confirmshowhide()">
                    <i v-if="showconfpass == true" class="pi pi-eye-slash"></i>
                    <i v-else class="pi pi-eye"></i>
                  </div>
                  <TextField :txttype="showConfirmtxt" v-model="ChangePasswordObjVal.confirmpassword" placeholder=" "
                    clearable name="Confirm Password" label="Confirm Password"
                    :rules="{ required: true, alphanumeric: true }" id="Confirm Password" :required-icon="true" />
                  <p v-if="showError" class="err_msg_style">
                    Password Must Be Same
                  </p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="d-flex flex-row-reverse pt-5">
                <!-- <AddButton btnname="Save" type="submit" /> -->
                <Footers class="py-2" label="Submit" :loading="loader" @cancel="Changepasswordpopup = false" />
              </b-col>
            </b-row>
          </b-form>
        </b-container>
      </Dialog>
    </b-navbar>
  </div>

  <!-- <div @click="mobileoptionvisible = false" class="inventory-router-view">
    <RouterView />
  </div> -->
  <div class="router-screen" @click="mobileoptionvisible = false">
    <div class="main-inner-screen">
      <RouterView />
    </div>
    <div class="footer-screen">
      <Footer @helpclick="helprouter()" />
    </div>
  </div>
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { computed, defineComponent, ref, reactive, onMounted } from "vue";
import { value } from "dom7";
import { useRoute, useRouter, Router, routeLocationKey } from "vue-router";
import StoreDropDown from "../../../../modules/Inventory/components/DropDown/HeaderStoreDropDown.vue";
import storeservice from "../../Service/StoreService";
import LoginService from "../../../../Services/LoginService";
import EntityMasterservice from "../../../../modules/Inventory/Service/EntityMasterService";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";

import MastersService from "../../Service/MastersService";
import PasswordService from "../../Service/PasswordService";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import ApprovalHistory from "../../../../modules/userManagement/Service/ApprovalHistory";
import WithoutStockAffectService from "../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useInventoryStore } from "../../../../modules/Inventory/stores/Index";
import Footer from "../../../../components/common/ProductFooter.vue";
import { setupHistoryManagement } from "../../../../modules/Inventory/Service/HistoryManage";
import Loader from "../../../../components/FormComponents/Loader.vue";
import Footers from "../../../../components/FormComponents/Footer.vue";
import CommonService from "../../Service/CommonService";
import ModuleSwitcher from "../../../../components/common/ModuleSwitcher.vue";
export default defineComponent({
  components: {
    Footer,
    StoreDropDown,
    TextField,
    UpdatedSuccessfully,
    Footers,
    ModuleSwitcher,
  },

  setup() {
    // const route = useRouter();
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const Changepasswordpopup = ref(false);
    const ModuleSwitcherpopup = ref(false);
    //get local storage session data
    const mobileoptionvisible = ref(false);
    const menu = ref();
    let name = ref("");
    const mystore = ref();
    const updatepop = ref(false);
    const inventoryStore = useInventoryStore();
    const items = ref([{ separator: true }]);
    const loader = ref(false);
    const toggle = (event) => {
      debugger;
      menu.value.toggle(event);
    };
    const mystoretoggle = (event) => {
      mystore.value.toggle(event);
    };
    const router = useRouter();

    const closesidebar = () => {
      visibleLeft.value = false;
    };

    function masters(routerPath) {
      visibleLeft.value = false;
      router.push(routerPath);
    }
    function helprouter() {
      window.open(usersData.HelpUrl, "_blank");
    }
    const visibleLeft = ref(false);
    const valueRef = ref("");
    const active = ref(false);

    const listed = ["2", "3"];

    // async function LogOut() {
    //   debugger;
    //   localStorage.clear();
    //   router.push({
    //     path: "/login",
    //   });
    // }

    async function LogOut() {
      debugger;
      const sourceApp = localStorage.getItem('SourceApp');
      const crossAppNavigation = localStorage.getItem('CrossAppNavigation');

      localStorage.clear();

      if (sourceApp === 'MOPUI' && crossAppNavigation === 'true') {
        try {
          const mopuiUrl = window.location.port === '5174' ? 'http://localhost:5173' : window.location.origin;
          window.location.href = `${mopuiUrl}/auth/login?logout=true&source=MoceroUI`;
        } catch (error) {
          console.error('Failed to navigate to MOPUI login, using standalone login:', error);
          router.push({ path: "/login" });
        }
      } else {
        router.push({ path: "/login" });
      }
    }


    function StoreChanged(data) {
      debugger;
      LoadPendingList(data.StoreId, data.StoreBranchmapId);
    }
    const mystoremodel = ref([
      {
        label: "Options",
        items: [
          {
            label: "Home",
            icon: "pi pi-fw pi-home",
            to: "/",
          },
          {
            label: "Menu 1",
            icon: "pi pi-fw pi-bars",
            items: [
              {
                label: "Submenu 1-1",
                to: "/submenu1-1",
              },
              {
                label: "Submenu 1-2",
                to: "/submenu1-2",
              },
            ],
          },
          {
            label: "Menu 2",
            icon: "pi pi-fw pi-bookmark",
            items: [
              {
                label: "Submenu 2-1",
                to: "/submenu2-1",
              },
              {
                label: "Submenu 2-2",
                to: "/submenu2-2",
              },
            ],
          },
        ],
      },
    ]);

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //
    let roleid = ref();
    let DeptRoleMapId = ref();

    const entitymenu = ref();
    const PendingTypemenu = ref();

    const entityitems = ref([]);
    const PendingType = ref([]);
    const entitytoggle = (event) => {
      debugger;
      entitymenu.value.toggle(event);
    };
    const Pendingtoggle = (event) => {
      PendingTypemenu.value.toggle(event);
    };
    let MainStoreList = ref({});
    let SubStoreList = ref({});
    let DepartmentStoreList = ref({});

    async function IsShow() {
      debugger;
      const result = await storeservice.getStoreList(
        usersData.OrganizationId,
        usersData.BranchId
      );
      console.log(result);
      MainStoreList.value = result["result"].filter(
        (item) => item.StoreTypeName == "Main Store"
      );
      SubStoreList.value = result["result"].filter(
        (item) => item.StoreTypeName == "Sub Store"
      );
      DepartmentStoreList.value = result["result"].filter(
        (item) => item.StoreTypeName == "Department Store"
      );
    }

    let menuarray: any = ref([]);

    async function LoadMenus() {
      debugger;
      let response = await MastersService.GetMenus(
        2,
        rolesData.RoleId,
        usersData.OrganizationId
      );

      console.log("MenuListStoreTabDetails", response["result"]);

      menuarray.value = response["result"];
    }

    let ProfileData = ref({
      UserNameFirstLetter: "",
      UserName: "",
      RoleName: "",
      phoneNumber: "",
    });

    function LoadProfile() {
      debugger;
      ProfileData.value.UserNameFirstLetter = usersData.UserName.charAt(0);
      ProfileData.value.UserName = usersData.UserName;
      ProfileData.value.RoleName = rolesData.RoleName;
      ProfileData.value.phoneNumber = usersData.phoneNumber;
    }
    const routes = useRoute();
    let SelectedBranchId = ref();

    let BranchDropDown: any = ref({
      BranchOption: [],
    });

    let SelectedRoleId = ref();
    let RoleDropDown: any = ref({
      RoleOption: [],
    });

    let BranchDropDownLength = ref();
    let RoleDropDownLength = ref();

    async function LoadProfileBranches() {
      debugger;
      const data_response = await LoginService.GetBranchesByUserId(
        usersData.UserId
      );
      console.log(data_response["result"]);

      BranchDropDownLength.value = data_response["result"].length;

      if (BranchDropDownLength.value != 1) {
        const allBranchIds = data_response["result"]
          .map((item) => item.BranchId)
          .join(",");

        data_response["result"].unshift({
          BranchId: allBranchIds,
          BranchName: "All",
          IsActive: true,
          HospitalBranchId: 0,
          HospitalBranchCode: "",
          BranchStateId: 0,
        });
      }

      BranchDropDown.value.BranchOption = data_response["result"].map(
        (item) => ({
          BranchName: item.BranchName,
          BranchId: item.BranchId,
          HospitalBranchId: item.HospitalBranchId,
          HospitalBranchCode: item.HospitalBranchCode,
          BranchStateId: item.BranchStateId,
        })
      );

      if (BranchDropDownLength.value == 1) {
        SelectedBranchId.value = {
          BranchName: data_response["result"][0].BranchName,
          BranchId: data_response["result"][0].BranchId,
          HospitalBranchId: data_response["result"][0].HospitalBranchId,
          HospitalBranchCode: data_response["result"][0].HospitalBranchCode,
          BranchStateId: data_response["result"][0].BranchStateId,
        };
      } else {
        let BranchValue = BranchDropDown.value.BranchOption.filter(
          (x) => x.BranchId == usersData.BranchId
        );

        SelectedBranchId.value = {
          BranchName: BranchValue[0].BranchName,
          BranchId: BranchValue[0].BranchId,
          HospitalBranchId: BranchValue[0].HospitalBranchId,
          HospitalBranchCode: BranchValue[0].HospitalBranchCode,
          BranchStateId: BranchValue[0].BranchStateId,
        };
      }
    }

    function BranchOnChange() {
      debugger;
      usersData.BranchId = SelectedBranchId.value.BranchId;
      usersData.HospitalBranchId = SelectedBranchId.value.HospitalBranchId;
      usersData.HospitalBranchCode = SelectedBranchId.value.HospitalBranchCode;
      usersData.BranchStateId = SelectedBranchId.value.BranchStateId;
      localStorage.setItem("UsersData", JSON.stringify(usersData));

      // router.push({
      //   path: "/Masters",
      // });
      // setupHistoryManagement(router, 2);

      let TabIndex = {
        Indexval: 0,
      };

      localStorage.removeItem("TabIndex");
      localStorage.setItem("TabIndex", JSON.stringify(TabIndex));

      localStorage.removeItem("RequestSubTabIndex");
      localStorage.setItem("RequestSubTabIndex", JSON.stringify(TabIndex));
      window.location.reload();
    }

    async function LoadprofileRoles() {
      debugger;
      const data_response = await LoginService.GetRolesByUserId(
        usersData.UserId,
        // SelectedBranchId.value.BranchId
        0
      );
      console.log(data_response["result"]);

      RoleDropDown.value.RoleOption = data_response["result"].map((item) => ({
        RoleName: item.RoleName,
        RoleId: item.RoleId,
        DeptRoleMapId: item.DeptRoleMapId,
      }));
      RoleDropDownLength.value = data_response["result"].length;

      if (RoleDropDownLength.value == 1) {
        SelectedRoleId.value = {
          RoleName: data_response["result"][0].RoleName,
          RoleId: data_response["result"][0].RoleId,
          DeptRoleMapId: data_response["result"][0].DeptRoleMapId,
        };
        RoleOnchange();
      } else {
        let RoleValue = RoleDropDown.value.RoleOption.filter(
          (x) => x.RoleId == rolesData.RoleId
        );

        SelectedRoleId.value = {
          RoleName: RoleValue[0].RoleName,
          RoleId: RoleValue[0].RoleId,
          DeptRoleMapId: RoleValue[0].DeptRoleMapId,
        };
      }
    }

    async function RoleOnchange() {
      debugger;

      console.log("Selected RoleId:", SelectedRoleId.value.RoleId);

      let ModuleId = 3;

      let GetRightsResponse = await EntityMasterservice.GetRightsByRoleId(
        SelectedRoleId.value.RoleId,
        ModuleId,
        usersData.OrganizationId
      );
      console.log(GetRightsResponse);

      localStorage.removeItem("RolesData");

      let RolesData = {
        RoleId: SelectedRoleId.value.RoleId,
        RoleName: SelectedRoleId.value.RoleName,
        DeptRoleMapId: SelectedRoleId.value.DeptRoleMapId,
      };

      localStorage.setItem("RolesData", JSON.stringify(RolesData));

      ProfileData.value.RoleName = SelectedRoleId.value.RoleName;

      // let existingUsersData = localStorage.getItem("UsersData");
      // let usersData1;
      // if (existingUsersData !== null) {
      //   usersData1 = JSON.parse(existingUsersData);
      // }
      // usersData1.BranchId = SelectedBranchId.value.BranchId;
      // localStorage.setItem("UsersData", JSON.stringify(usersData1));

      if (RoleDropDownLength.value > 1) {
        router.push({
          path: "/Masters",
        });
        window.location.reload();
      }
    }

    function navigate(strId, storestatus) {
      router.push({
        name: "StoreTabDetails",
        query: {
          status: storestatus,
          Id: strId,
          Type: "StoreId",
        },
      });
      visibleLeft.value = false;
    }

    // function routeto() {
    //   visibleLeft.value = false;
    //   router.push({
    //     path: "/dashboard",
    //     name: "dashboard",
    //     // query: {
    //     //   status: storestatus,
    //     //   Id: strId,
    //     //   Type: "StoreId",
    //     // },
    //   });
    //   visibleLeft.value = false;
    // }

    let ChangePasswordObjVal = ref({
      newpassword: "",
      confirmpassword: "",
    });

    let UserChangePasswordObjVal = ref({
      UserId: 0,
      Password: "",
    });

    const copyupdatepassword = JSON.parse(
      JSON.stringify(ChangePasswordObjVal.value)
    );

    const showError = ref(false);
    const IsStoreSubmit = handleSubmit(async (values) => {
      debugger;
      loader.value = true;
      if (
        ChangePasswordObjVal.value.confirmpassword !==
        ChangePasswordObjVal.value.newpassword
      ) {
        loader.value = false;
        showError.value = true;
      } else {
        showError.value = false;

        UserChangePasswordObjVal.value.UserId = usersData.UserId;

        UserChangePasswordObjVal.value.Password =
          ChangePasswordObjVal.value.confirmpassword;

        let response = await PasswordService.ChangePassword(
          UserChangePasswordObjVal.value
        );
        console.log(response["result"]);

        let msg = response["ErrorInfo"].ErrorCode;

        if (msg == null) {
          loader.value = false;
          updatepop.value = true;
        } else {
          loader.value = false;
          alert("Somthing went wrong");
        }
      }
    });

    function closetrigger() {
      updatepop.value = false;
      LogOut();
    }

    let showpass = ref(true);
    let showconfpass = ref(true);
    let showtxt = ref("Password");
    let showConfirmtxt = ref("Password");
    function showhide() {
      if (showpass.value == true) {
        showpass.value = false;
        showtxt.value = "text";
      } else {
        showpass.value = true;
        showtxt.value = "Password";
      }
    }
    function confirmshowhide() {
      debugger;
      if (showconfpass.value == true) {
        showconfpass.value = false;
        showConfirmtxt.value = "text";
      } else {
        showconfpass.value = true;
        showConfirmtxt.value = "Password";
      }
    }
    //Clear
    function IsClear() {
      debugger;
      Object.assign(ChangePasswordObjVal.value, copyupdatepassword);
    }

    function mobileoptiontoggle() {
      mobileoptionvisible.value = !mobileoptionvisible.value;
    }

    let pendingrequestcount = ref();
    let pendingListcount = ref(0);

    const LoadWorkList = async () => {
      debugger;
      let result = await ApprovalHistory.GetListByDeptRoleId(
        DeptRoleMapId.value
      );

      let branchIds =
        typeof usersData.BranchId === "string" &&
          usersData.BranchId.includes(",")
          ? usersData.BranchId.split(",")
          : [usersData.BranchId.toString()];

      entityitems.value = result["result"].filter(
        (x) =>
          branchIds.includes(x.BranchId.toString()) &&
          x.HospitalId == usersData.OrganizationId
      );

      console.log(entityitems.value);
      pendingrequestcount.value = entityitems.value.reduce(
        (total, item) => total + (item["ListCount"] || 0),
        0
      );
      console.log("Total ListCount:", pendingrequestcount.value);
    };

    const LoadPendingList = async (StoreId, StorebranchmapId) => {
      if (StoreId != 0 && StorebranchmapId != 0) {
        debugger;
        let result = await WithoutStockAffectService.GetPendingListCount(
          usersData.OrganizationId,
          usersData.BranchId,
          StoreId,
          StorebranchmapId
        );
        debugger;
        pendingListcount.value = 0;
        console.log(result["result"]);
        PendingType.value = result["result"];
        console.log(PendingType.value);
        for (let item of PendingType.value) {
          pendingListcount.value += item["Count"];
        }
        console.log("Total ListCount:", pendingrequestcount.value);
      }
    };

    const poapprovaltablecall = (EntityId) => {
      router.push({
        name: "entitywiseApprovalTableView",
        query: {
          EntityId: EntityId,
        },
      });
      entitymenu.value.toggle(false);
    };

    const PendingListChange = (EntityId) => {
      debugger;
      inventoryStore.MenuTab = EntityId;
      PendingTypemenu.value.toggle(false);
    };

    // Module loading state
    const modules = ref<any[]>([]);
    const moduleLoading = ref(false);
    const moduleError = ref<string | null>(null);

    // Load available modules
    async function loadAvailableModules() {
      try {
        moduleLoading.value = true;
        moduleError.value = null;

        const response: any = await CommonService.GetModulesByOrganizationId(usersData.OrganizationId);
        console.log("ModuleList", response.result);

        if (response && response.result) {
          // Map the API response to include proper icons, colors, and types
          modules.value = response.result.map((module: any) => ({
            ...module,
            icon: getModuleIcon(module.Name),
            color: getModuleColor(module.Name),
            type: getModuleType(module.Name)
          }));
        }
      } catch (error) {
        console.error('Error loading modules:', error);
        moduleError.value = 'Failed to load modules';
      } finally {
        moduleLoading.value = false;
      }
    }

    // Helper functions for module display
    function getModuleIcon(moduleName: string): string {


      const iconMap: { [key: string]: string } = {
        'Inventory': 'pi pi-box',
        'CRM': 'pi pi-users',
        'Billing': 'pi pi-money-bill',
        'User Management': 'pi pi-user-edit',
        'Communication': 'pi pi-comments',
        'Alert Engine': 'pi pi-bell'
      };
      return iconMap[moduleName] || 'pi pi-th-large';
    }

    function getModuleColor(moduleName: string): string {
      const colorMap: { [key: string]: string } = {
        'Inventory': '#4CAF50',
        'CRM': '#2196F3',
        'Billing': '#FF9800',
        'User Management': '#9C27B0',
        'Communication': '#00BCD4',
        'Alert Engine': '#F44336'
      };
      return colorMap[moduleName] || '#607D8B';
    }

    function getModuleType(moduleName: string): string {
      // Determine if module belongs to MOPUI or MoceroUI
      const moceroUIModules = ['Inventory', 'CRM', 'Billing', 'User Management', 'Communication', 'Alert Engine'];
      return moceroUIModules.includes(moduleName) ? 'MoceroUI' : 'MOPUI';
    }

    // Load modules on component mount
    onMounted(() => {
      debugger;
      roleid.value = rolesData.RoleId == null ? 0 : rolesData.RoleId;
      DeptRoleMapId.value =
        rolesData.DeptRoleMapId == null ? 0 : rolesData.DeptRoleMapId;
      LoadMenus();
      LoadProfile();
      LoadProfileBranches();
      LoadWorkList();
      LoadprofileRoles();
      loadAvailableModules(); // Load modules
      // IsShow();
    });

    // Clear module data when dialog closes
    function ClearModuleData() {
      // Reset any temporary data if needed
    }

    return {
      helprouter,
      showpass,
      showconfpass,
      showtxt,
      showConfirmtxt,
      showhide,
      confirmshowhide,
      IsClear,
      showError,
      ChangePasswordObjVal,
      IsStoreSubmit,
      // routeto,
      MainStoreList,
      SubStoreList,
      DepartmentStoreList,
      navigate,
      mystore,
      mystoremodel,
      mystoretoggle,
      closesidebar,
      LogOut,
      menu,
      items,
      toggle,
      masters,
      visibleLeft,
      handleSelect(key: string | number) {
        // alert(key);
      },
      generalOptions: listed.map((v) => ({
        label: v,
        value: v,
      })),

      active,
      value: valueRef,
      options: computed(() => {
        return ["@gmail.com", "@163.com", "@qq.com"].map((suffix) => {
          const prefix = valueRef.value.split("@")[0];
          return {
            label: prefix + suffix,
            value: prefix + suffix,
          };
        });
      }),

      ProfileData,
      SelectedRoleId,
      RoleDropDown,
      RoleOnchange,
      RoleDropDownLength,
      BranchDropDownLength,
      BranchDropDown,
      SelectedBranchId,
      BranchOnChange,
      Changepasswordpopup,
      menuarray,
      closetrigger,
      updatepop,
      mobileoptionvisible,
      mobileoptiontoggle,
      entitytoggle,
      Pendingtoggle,
      entityitems,
      PendingType,
      entitymenu,
      LoadWorkList,
      poapprovaltablecall,
      PendingListChange,
      pendingrequestcount,
      pendingListcount,
      PendingTypemenu,
      StoreChanged,
      loader,
      router,
      // Module Switcher
      ModuleSwitcherpopup,
      modules,
      moduleLoading,
      moduleError,
      loadAvailableModules,
      ClearModuleData
    };
  },
});
</script>

<style scoped></style>
